const prefersDarkMQ = '(prefers-color-scheme: dark)';

const getPreferredTheme = () => 
  window.matchMedia(prefersDarkMQ).matches ? 'dark' : 'light';

const updateHtmlTag = (str) => {
  const html = document.querySelector('html');
  html?.setAttribute('data-theme', str);
};

const changeFavicon = (newVal) => {
  const selector = [
    'link[rel="apple-touch-icon"]',
    'link[rel="manifest"]',
    'link[rel="mask-icon"]',
    'link[rel="icon"]'
  ]
  const arr = selector.map(item=>document.querySelector(item))
  arr.forEach((dom)=>{
    const favicon = dom
    if (favicon == null)  return
    const path = favicon.href.replace(/light|dark/gi, newVal)
    favicon.href = path
  })
}
  
export { updateHtmlTag, getPreferredTheme, prefersDarkMQ, changeFavicon };